import Image from "next/image";
import Link from "next/link";
import React from "react";
import striptags from "striptags";

const AgileBanner = ({ industryData }) => {
  const titleWithoutPTag = industryData?.value?.title;
  return (
    <section className="agile-banner-section">
      <div className="agile-banner-inner">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="agile-banner-content">
                <div className="agile-banner-heading">
                  <div className="agile-main-heading">
                    <h1
                      dangerouslySetInnerHTML={{
                        __html: titleWithoutPTag,
                      }}
                    ></h1>
                    <span
                      className="agile-banner-subheading margin-bottom-10"
                      dangerouslySetInnerHTML={{
                        __html: industryData?.value?.description,
                      }}
                    ></span>
                  </div>
                </div>
                <div className="agile-banner-description">
                  <p
                    dangerouslySetInnerHTML={{
                      __html: industryData?.value?.paragraph,
                    }}
                  ></p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 content-center">
              <div className="agile-banner-right">
                <div className="agile-banner-image">
                  <Image
                    height={500}
                    width={500}
                    src={industryData?.value?.list?.image?.url}
                    alt={industryData?.value?.list?.image?.alt_text ?? 'EdTech Industry'}
                    loading="eager"
                    priority
                  />
                </div>
                <div className="agile-banner-link">
                  <Link
                    href={industryData?.value?.list?.card_link?.url}
                    itemProp="link"
                    className="card-link"
                  >
                    <span className="card-link-text">
                      {industryData?.value?.list?.card_link_text}
                    </span>
                    <span className="arrow-down"></span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AgileBanner;
